import { formSections } from 'constants/ccmClinicalNotesForms';
import PropTypes from 'prop-types';
import useCcmClinicalNotesModal from 'utils/useCcmClinicalNotesModal';
import DraggableModal from 'components/organisms/draggableModal';
import BaseSpinWrapper from 'components/atoms/base-spin-wrapper';
import Section from 'components/molecules/section';
import BaseButton from 'components/atoms/baseButton';

import s from './styles.module.scss';

const CcmClinicalNotesModal = ({
  onSubmit,
  closeModal,
  isOpen,
  patientGuid,
}) => {
  const {
    values,
    currentStep,
    errorSections,
    canEditPage,
    isLoading,
    setValue,
    goToPrevStep,
    goToNextStep,
    submit,
    bodyRef,
  } = useCcmClinicalNotesModal({
    onSubmit,
    closeModal,
    patientGuid,
  });

  return (
    <DraggableModal
      isOpen={isOpen}
      toggle={closeModal}
      title={`${formSections[currentStep].title} - ${currentStep + 1} of ${
        formSections.length
      }`}
      footerClassName={s['footer-wrapper']}
      bodyRef={bodyRef}
      footer={
        <>
          <div>
            {currentStep === formSections.length - 1 &&
              errorSections.length > 0 && (
                <p className={s['error-fields']} data-cy="modal-error">
                  Missing fields in section(s): {errorSections.join(', ')}{' '}
                </p>
              )}
            {currentStep !== 0 && (
              <BaseButton
                onClick={goToPrevStep}
                label="< Back"
                type="secondary"
                dataCy="back-btn"
              />
            )}
            {currentStep === formSections.length - 1 ? (
              <>
                <BaseButton
                  disabled={errorSections.length}
                  onClick={submit}
                  label="Submit"
                />
              </>
            ) : (
              <BaseButton
                onClick={goToNextStep}
                label="Forward >"
                data-cy="forward-btn"
                type="secondary"
              />
            )}
          </div>
        </>
      }
    >
      <BaseSpinWrapper spinning={isLoading}>
        <div className="narrative-popup">
          <Section
            forms={formSections[currentStep].forms}
            setValue={setValue}
            values={values}
            canEditPage={canEditPage}
          />
        </div>
      </BaseSpinWrapper>
    </DraggableModal>
  );
};

CcmClinicalNotesModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  patientGuid: PropTypes.string,
};

export default CcmClinicalNotesModal;
